import { confirmToast } from "../../utils/toast";
import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosConfig";

const YearSetting = () => {
  const [years, setYears] = useState([]);
  const [form, setForm] = useState({ YearName: "", FromDate: "", ToDate: "", IsActive: false });
  const [editId, setEditId] = useState(null);
  const [msg, setMsg] = useState("");

  useEffect(() => { loadYears(); }, []);

  const loadYears = async () => {
    try {
      const res = await axios.get("/year-settings");
      setYears(res.data);
    } catch { }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      if (editId) {
        await axios.put(`/year-settings/${editId}`, form);
        setMsg("Year updated.");
      } else {
        await axios.post("/year-settings", form);
        setMsg("Year added.");
      }
      alert(editId ? "Year updated successfully" : "Year saved successfully");
      setForm({ YearName: "", FromDate: "", ToDate: "", IsActive: false });
      setEditId(null);
      loadYears();
    } catch (err) {
      const message = err.response?.data?.message || "Error saving year.";
      setMsg(message);
      alert(message);
    }
  };

  const handleEdit = y => {
    setEditId(y.YearID);
    setForm({
      YearName: y.YearName,
      FromDate: y.FromDate?.split("T")[0] || "",
      ToDate: y.ToDate?.split("T")[0] || "",
      IsActive: y.IsActive
    });
  };

  const handleDelete = async id => {
    if (!await confirmToast("Delete this year?")) return;
    await axios.delete(`/year-settings/${id}`);
    loadYears();
  };

  const handleSetActive = async id => {
    await axios.put(`/year-settings/${id}/set-active`);
    loadYears();
  };

  return (
    <div className="container-fluid mt-3">
      <div className="card shadow-sm border-0">
        <div className="card-header bg-white">
          <span className="badge bg-success fs-6 px-3 py-2">Year Setting</span>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit} className="row g-3 mb-4">
            <div className="col-md-3">
              <label className="form-label">Year Name</label>
              <input className="form-control form-control-sm" placeholder="e.g. 2024-25"
                value={form.YearName} onChange={e => setForm({ ...form, YearName: e.target.value })} required />
            </div>
            <div className="col-md-2">
              <label className="form-label">From Date</label>
              <input type="date" className="form-control form-control-sm"
                value={form.FromDate} onChange={e => setForm({ ...form, FromDate: e.target.value })} required />
            </div>
            <div className="col-md-2">
              <label className="form-label">To Date</label>
              <input type="date" className="form-control form-control-sm"
                value={form.ToDate} onChange={e => setForm({ ...form, ToDate: e.target.value })} required />
            </div>
            <div className="col-md-2 d-flex align-items-end gap-2">
              <button className="btn btn-success btn-sm">{editId ? "Update" : "Add Year"}</button>
              {editId && <button type="button" className="btn btn-secondary btn-sm"
                onClick={() => { setEditId(null); setForm({ YearName: "", FromDate: "", ToDate: "", IsActive: false }); }}>Cancel</button>}
            </div>
            {msg && <div className="col-12"><small className="text-success">{msg}</small></div>}
          </form>

          <table className="table table-bordered table-sm" style={{ fontSize: "13px" }}>
            <thead className="table-success">
              <tr><th>#</th><th>Year Name</th><th>From Date</th><th>To Date</th><th>Active</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {years.length === 0
                ? <tr><td colSpan={6} className="text-center text-muted">No years added.</td></tr>
                : years.map((y, i) => (
                  <tr key={y.YearID}>
                    <td>{i + 1}</td>
                    <td>{y.YearName}</td>
                    <td>{y.FromDate?.split("T")[0]}</td>
                    <td>{y.ToDate?.split("T")[0]}</td>
                    <td>{y.IsActive ? <span className="badge bg-success">Active</span> : <span className="badge bg-secondary">Inactive</span>}</td>
                    <td className="d-flex gap-1">
                      <button className="btn btn-sm btn-outline-primary" onClick={() => handleEdit(y)}>Edit</button>
                      {!y.IsActive && <button className="btn btn-sm btn-outline-success" onClick={() => handleSetActive(y.YearID)}>Set Active</button>}
                      <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(y.YearID)}>Delete</button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default YearSetting;
